import { BaseRemoteDataSource } from '@base-data-sources';
import { BaseEntity, BaseDataSourceConstructorEntity } from '@base-entities';

export class CommonRemoteDataSource<E extends BaseEntity = BaseEntity> extends BaseRemoteDataSource<E> {
  constructor(params: BaseDataSourceConstructorEntity) {
    super(params);
  }
}
